<template>

  <div class="for-selcet-box" v-if="route.path === '/register'">
    <div class="prepend">sephora.com/creators/</div>
    <el-select :model-value="getHandleValue" placeholder="---Select---" popper-class="custom-select-picker" :key="keyRef">
      <template #label>
        <span>{{ getHandleValue?.handle || '---Select---' }}</span>
      </template>

      <el-option v-for="(item, index) in RegisterStore.spHandle" :key="index" class="items-center" :value="`${item.handle}-fake`"
        :class="{ 'is-selected': getHandleValue?.handle === item.handle }"
        @click="handleSelect(item)">
        <svg-icon v-if="item.icon" :name="item.icon" />
        <span>{{ item.handle }}</span>
      </el-option>
    </el-select>
  </div>

</template>

<script setup>
import { ref, onMounted ,watch} from 'vue';
import { useGlobalStore } from '@/stores/GlobalStore';
import emitter from '@shared/utils/EventBus';
import { useRegisterStore } from '@/stores/RegisterStore';
import {useRouter,useRoute} from 'vue-router';
import ajax from '@/utils/Ajax';
import { useNotification } from '@shared/components/ui/notification';
const router = useRouter();
const route = useRoute();
const store = useGlobalStore();
const emit = defineEmits(['updateHandle']);
const RegisterStore = useRegisterStore();
const getHandleValue = ref(null);
const keyRef= ref(0);
const { openNotBottom } = useNotification();


//++++++++++++++++++++++
//handle get icon
const handleSelect = (item) => {
  getHandleValue.value = item;
  emit('updateHandle', item.handle);
  keyRef.value+=1;
};

const start=()=>{
  RegisterStore.spHandle.forEach((e) => {
    const social = store.initSocial.find(i => i.backName.includes(e.social_platform));
    e.icon = !social ? 'people' : social.icon;
  });
  getHandleValue.value = RegisterStore.spHandle.length>0?RegisterStore.spHandle[0]:null;
  if(getHandleValue.value){
    emit('updateHandle', RegisterStore.spHandle[0].handle);
    keyRef.value+=1;
  }

};

watch(
  () => RegisterStore.spHandle.length,
  () => {
    start();
  },
  { immediate: true }
);
//+++++++++++++++++++++++
onMounted(() => {
  start();
});
</script>

<style lang="scss">
.for-selcet-box {
  display: grid;
  grid-template-columns: auto 1fr;
  width: 100%;

  @media (max-width: $mobile_size) {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .prepend {
    color: var(--Text-primary);
    background-color: var(--Neu-30);
    padding: 0 16px;
    @include flexCenter;
    border-radius: 6px 0 0 6px;

    @media (max-width: $mobile_size) {
      border-radius: var(--radius);
      height: 40px;
    }
  }

  .ui-select {
    margin: 0;
  }

  .ui-select .ui-select__wrapper {
    width: 100%;
    border-radius: 0px 6px 6px 0px;
    max-height: 40px;
    height: 40px !important;

    @media (max-width: $mobile_size) {
      border-radius: var(--radius);
    }
    // .svg-icon {
    //   color: var(--Black-100);
    // }

    &.is-disabled {
      background-color: var(--Black-00);

      .ui-select__selected-item {
        color: var(--Text-secondary);
      }
    }
  }
}
</style>
